{
  "name": "mail-logging",
  "version": "2.1.22",
  "description": "mail-logging",
  "private": true,
  "engines": {
    "node": "24",
    "npm": "11"
  },
  "scripts": {
    "set-env": "ts-node set-env.ts",
    "start": "node backend/dist/index.js",
    "test": "cd backend && npm run test",
    "batch": "cd backend && npm run batch",
    "backend:watch": "cd backend && npm run dev:watch",
    "build": "cd backend && tsc && cd .. && ng build --configuration production",
    "sdk": "cd backend && npm run sdk",
    "sdk:watch": "cd backend && npm run sdk:watch ",
    "angular:watch": "ng build --watch",
    "angular:serve": "ng serve --host=0.0.0.0 --port 4200 --proxy-config proxy.config.json",
    "dev:watch": "concurrently --names \"Angular,Backend,SDK\" -c \"bgGreen.bold,bgBlue.bold,bgMagenta.bold\" \"npm run angular:watch\" \"npm run backend:watch\" \"npm run sdk:watch\"",
    "dev:serve": "concurrently --names \"Angular,Backend,SDK\" -c \"bgGreen.bold,bgBlue.bold,bgMagenta.bold\" \"npm run angular:serve\" \"npm run backend:watch\" \"npm run sdk:watch\"",
    "postinstall": "cd backend && npm i",
    "release": "generate-release"
  },
  "config": {
    "generateRelease": {
      "files_to_version": [
        "azure-pipelines.yml",
        "backend/package.json",
        "backend/package-lock.json",
        "package-lock.json"
      ]
    }
  },
  "dependencies": {
    "@angular-devkit/build-angular": "^21.1.3",
    "@angular/animations": "^21.1.3",
    "@angular/cli": "^21.1.3",
    "@angular/common": "^21.1.3",
    "@angular/compiler": "^21.1.3",
    "@angular/compiler-cli": "^21.1.3",
    "@angular/core": "^21.1.3",
    "@angular/forms": "^21.1.3",
    "@angular/localize": "^21.1.3",
    "@angular/platform-browser": "^21.1.3",
    "@angular/platform-browser-dynamic": "^21.1.3",
    "@angular/router": "^21.1.3",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@openapitools/openapi-generator-cli": "^2.25.2",
    "@popperjs/core": "2.11.8",
    "bootstrap": "5.3.8",
    "colors": "^1.4.0",
    "moment": "^2.30.1",
    "ngx-toastr": "^20.0.0",
    "postal-mime": "^1.1.0",
    "rxjs": "^7.8.1",
    "sanitize-html": "^2.17.0",
    "stacktrace-gps": "^3.1.2",
    "stacktrace-js": "^2.0.2",
    "tslib": "^2.7.0",
    "typescript": "^5.9.3",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.0.0",
    "@angular-eslint/eslint-plugin": "^21.0.0",
    "@angular-eslint/eslint-plugin-template": "^21.0.0",
    "@angular-eslint/schematics": "^21.0.0",
    "@angular-eslint/template-parser": "^21.0.0",
    "@types/lodash": "^4.17.21",
    "@types/node": "^22.18.12",
    "@types/sanitize-html": "^2.16.0",
    "@typescript-eslint/eslint-plugin": "^7.18.0",
    "@typescript-eslint/parser": "^7.18.0",
    "concurrently": "^8.2.2",
    "dotenv": "^16.6.1",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^9.1.2",
    "eslint-plugin-imengine": "file:eslint",
    "eslint-plugin-prettier": "^5.5.4",
    "generate-release": "^1.1.1",
    "nodemon": "^3.1.10",
    "prettier": "^3.6.2",
    "tslint": "~6.1.0"
  },
  "overrides": {
    "shell-quote": "^1.8.4",
    "esbuild": "^0.28.1",
    "uuid": "^11.1.1",
    "webpack-dev-server": "^5.2.4",
    "postcss": "^8.5.20",
    "piscina": "^5.3.2",
    "basic-ftp": "^6.2.1"
  }
,
"build":"main-37486-v2.1.22"}
